import { HorizontalAlign } from "../types/align/HorizontalAlign"
import { VerticalAlign } from "../types/align/VerticalAlign"
import type { PlottingContext } from "../types/options/PlottingContext"
import type { Distance, Percentage, Pixel } from "../types/units/Units"

export const CreateContext = (
  context: PlottingContext
): Required<PlottingContext> => ({
  color_map: {},
  file_map: {},
  scale_map: {},
  unit_to_px: 1,
  page_bleed: 0 as Distance,
  scale_bleed: 0 as Distance,
  stroke_width: 1 as Distance,
  font_size: 12 as Pixel,
  font_height_adjustment: 0.61 as Percentage,
  font_family: "Helvetica",
  vertical_align: VerticalAlign.CENTER,
  horizontal_align: HorizontalAlign.CENTER,
  image_resolution: 300 as Pixel,
  ...context,
})
